import React from "react";
import TenantCards from "../../../../tenantComponent/common/cards/TenantCards";
import CurrentTenantCard from "../../../listings/listing-cards/current-tenant";
import ProspectTenantCard from "../../../listings/listing-cards/prospect-tenant";
import Tenants from "../../../../pages/tenants";
import { useParams } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";
 
interface TenantTabContentProps {
   result: any[];
 }
 
 const TenantTabContent: React.FC<TenantTabContentProps> = ({result}) => {
  const { id } = useParams();
 
    return (
      <>
      {/* <CurrentTenantCard Id="tenant-123" IsFooter={true} />
      <ProspectTenantCard Id="tenant-123" IsFooter={true} /> */}
      <Tenants isEntity={true} entityId={Number(id)}  className="no-side-margin"  detailsActiveTab="Tenants" />
      </>
    )
}


export default TenantTabContent;